import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'
import * as EntitiesActionTypes from '../../entities/actionTypes'
import {TaskSortBy} from '../constants'
import {arrayToSet} from '../../atUtils'

const createReducer = ({
    TASK_MANAGEMENT = {}
}) => {
    const pageSettings = TASK_MANAGEMENT.PAGE_SETTINGS || {}

    const columnsOrder = (pageSettings.columnsOrder) ? JSON.parse(pageSettings.columnsOrder) : []
    const columnsShown = (pageSettings.columnsDisplay) ? JSON.parse(pageSettings.columnsDisplay) : []
    const initialState = {
        sorting: {
            by: pageSettings.sortBy || TaskSortBy.TASK,
            asc: pageSettings.ascSort || false,
        },
        isLoaded: false,
        columnsOrder: columnsOrder,
        columnsShown: columnsShown,

        loadedTaskIds: [],
    }

    return handleActions({
        [ActionTypes.TASKS_SORTING_CHANGE]: (state, {payload: sorting}) => ({
            ...state,
            sorting,
        }),
        [ActionTypes.COLUMNS_ORDER_SET]: (state, {payload: columnsOrder}) => ({
            ...state,
            columnsOrder: columnsOrder,
        }),
        [ActionTypes.COLUMNS_SHOWN_SET]: (state, {payload: columnsShown}) => ({
            ...state,
            columnsShown: columnsShown,
        }),
        [ActionTypes.IS_LOADED_SET]: (state, {payload: isLoaded}) => ({
            ...state,
            isLoaded: isLoaded,
        }),

        [ActionTypes.LOADED_TASK_IDS_SET]: (state, {payload: loadedTaskIds}) => ({
            ...state,
            loadedTaskIds
        }),
        [ActionTypes.LOADED_TASK_IDS_ADD]: (state, {payload: ids}) => ({
            ...state,
            loadedTaskIds: state.loadedTaskIds.concat(ids)
        }),
        [ActionTypes.LOADED_TASK_IDS_PREPEND]: (state, {payload: ids}) => ({
            ...state,
            loadedTaskIds: ids.concat(state.loadedTaskIds)
        }),
        [EntitiesActionTypes.TASKS_REMOVE]: (state, {payload: ids}) => {
            const taskIdsSet = arrayToSet(ids)
            return {
                ...state,
                loadedTaskIds: state.loadedTaskIds.filter((id) => !taskIdsSet[id])
            }
        },
    }, initialState)
}

export default createReducer



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/reducer.js